var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v("Аналитика")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "b-button",
              {
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "show-charts" },
                on: { click: _vm.toggleChart }
              },
              [_c("font-awesome-icon", { attrs: { icon: "chart-bar" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "show-charts",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Графики\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-fields",
                    modifiers: { "sidebar-fields": true }
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" }
              },
              [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Колонки\n      ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "div",
            { staticClass: "page-filters" },
            [
              _c(
                "filters-drawer",
                {
                  attrs: {
                    "hide-search": true,
                    "is-busy": _vm.isBusy,
                    "filter-tags": _vm.activeFilterTags,
                    "disabled-submit": _vm.isDateEmpty
                  },
                  on: {
                    "remove-tag": _vm.removeFilterTag,
                    submit: _vm.onSearch,
                    clear: _vm.onClearFilters
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Период")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input_startDate",
                                  size: "sm",
                                  type: "date",
                                  state: _vm.isDateEmpty ? false : null
                                },
                                model: {
                                  value: _vm.filters.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "startDate", $$v)
                                  },
                                  expression: "filters.startDate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "auto" } },
                            [_c("span", [_vm._v("—")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input_endDate",
                                  size: "sm",
                                  type: "date",
                                  state: _vm.isDateEmpty ? false : null
                                },
                                model: {
                                  value: _vm.filters.endDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filters, "endDate", $$v)
                                  },
                                  expression: "filters.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isDateEmpty
                    ? _c(
                        "b-col",
                        {
                          staticClass: "d-flex justify-content-center",
                          attrs: { cols: "12" }
                        },
                        [
                          _c("small", { staticClass: "text-danger" }, [
                            _vm._v("Укажите даты периода!")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Объекты")
                      ]),
                      _vm._v(" "),
                      _c("location-multi-select", {
                        ref: "location_multi_select",
                        attrs: { id: "location_multi_select" },
                        on: { onSelect: _vm.onSelectLocation }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Сотрудники")
                      ]),
                      _vm._v(" "),
                      _vm.canReadOther()
                        ? _c("user-multi-select", {
                            ref: "user_multi_select",
                            attrs: { id: "user_multi_select" },
                            on: { onSelect: _vm.onSelectUser }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  { staticClass: "page-table-container" },
                  [
                    _c("b-table", {
                      ref: "calculator_project",
                      staticClass: "custom-table mb-0 text-small",
                      attrs: {
                        id: "calculator-project",
                        "sticky-header": "",
                        selectable: "",
                        "select-mode": "single",
                        responsive: "",
                        busy: _vm.isBusy,
                        items: _vm.items,
                        fields: _vm.renderedFields,
                        "foot-clone": true,
                        "no-footer-sorting": "",
                        "no-provider-filtering": "",
                        "no-provider-paging": "",
                        "no-provider-sorting": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c("tables-skeleton", {
                                  attrs: { fields: _vm.renderedFields, rows: 6 }
                                })
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(index)",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(data.index + 1) +
                                    "\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(payment)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(_vm.price(row.item.payment)))
                              ]
                            }
                          },
                          {
                            key: "cell(nds_price)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(_vm.price(row.item.nds_price)))
                              ]
                            }
                          },
                          {
                            key: "cell(payment_without_nds)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(row.item.payment_without_nds)
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_nds_price)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.total_nds_price))
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_price_without_nds)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(row.item.total_price_without_nds)
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(percent_profit)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.percent_profit))
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(management_expenses)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(row.item.management_expenses)
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_price_without_expenses)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(
                                      row.item.total_price_without_expenses
                                    )
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_workers_service_commission)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(
                                      row.item.total_workers_service_commission
                                    )
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_workers_with_commission)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(
                                      row.item.total_workers_with_commission
                                    )
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(hours_count)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(_vm.price(row.item.hours_count)))
                              ]
                            }
                          },
                          {
                            key: "cell(total_price)",
                            fn: function(row) {
                              return [
                                _vm._v(_vm._s(_vm.price(row.item.total_price)))
                              ]
                            }
                          },
                          {
                            key: "cell(total_workers)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.total_workers))
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(custom_total_delta)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.custom_total_delta))
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_manager)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.total_manager))
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_project)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.total_project))
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(profit_with_man_exp)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(row.item.profit_with_man_exp)
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(profit_without_man_exp)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.price(row.item.profit_without_man_exp)
                                  )
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(marginality)",
                            fn: function(row) {
                              return [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "large" } },
                                  [
                                    _c(
                                      "b-badge",
                                      {
                                        attrs: {
                                          variant: _vm.getMarginalityVariant(
                                            row.item
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.price(row.item.marginality)
                                          ) + " %"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(task_exit)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.price(row.item.task_exit)) +
                                    " %\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(location_payment_type)",
                            fn: function(row) {
                              return [
                                _c("font-awesome-icon", {
                                  style: _vm.paymentTypeStyle(
                                    row.item.location_payment_type
                                  ),
                                  attrs: {
                                    set: (_vm.pt = _vm.paymentTypeIcon(
                                      row.item.location_payment_type
                                    )),
                                    icon: ["fas", _vm.pt.icon],
                                    title: _vm.pt.title
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(partners_price)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.partners_price))
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(recruitment_price)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.price(row.item.recruitment_price))
                                )
                              ]
                            }
                          },
                          _vm.total != null
                            ? {
                                key: "foot()",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.price(_vm.total[row.field.key])
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              }
                            : null
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _vm.showChart
                      ? _c(
                          "div",
                          [
                            _vm.isBusy
                              ? _c(
                                  "b-card",
                                  {
                                    staticClass: "text-center text-muted",
                                    attrs: { size: "sm" }
                                  },
                                  [
                                    _vm.isBusy
                                      ? _c("b-spinner", {
                                          staticClass: "align-middle"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isBusy
                                      ? _c("strong", { staticClass: "ml-2" }, [
                                          _vm._v("Загрузка графика...")
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _c("e-chart-builder", {
                                  staticClass: "EChart",
                                  attrs: {
                                    "chart-id": "analytics-chart",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "per-page": _vm.perPage
                                  },
                                  on: { "toggle-index": _vm.toggleIndexField }
                                })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "use-router": "",
                        "current-page": _vm.currentPage,
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage,
                        "page-options": _vm.pageOptions
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      }
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Нет записей в аналитике.")])
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "analytics_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "location_id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-877228c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-877228c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analytics/Analytics.vue
// module id = null
// module chunks = 